var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage133(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.198,
    height: 20.804,
    viewBox: "0 0 38.198 20.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(-1154 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cash",
    transform: "translate(1119.25 372.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M72.947,154.9a1.405,1.405,0,0,1-1.405,1.405H36.155A1.405,1.405,0,0,1,34.75,154.9V136.905a1.405,1.405,0,0,1,1.405-1.405H71.542a1.405,1.405,0,0,1,1.405,1.405Zm-1.381-17.951a.066.066,0,0,0-.066-.066H36.2a.066.066,0,0,0-.066.066v17.908a.066.066,0,0,0,.066.066H71.5a.066.066,0,0,0,.066-.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M60.1,160.582q.028,1.371,0,2.759a1.127,1.127,0,0,1-.133.586.7.7,0,0,1-1.129-.026,1.06,1.06,0,0,1-.108-.54q0-1.3,0-2.607a1.421,1.421,0,0,1,1.475-1.615c.6,0,2.944-.152,3.327.169a.685.685,0,0,1-.522,1.208q-1.431,0-2.843,0a.063.063,0,0,0-.063.065Z",
    transform: "translate(-21.91 -21.565)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M395.584,160.816a.7.7,0,1,1-.043-1.388q2.138-.008,2.831,0a1.422,1.422,0,0,1,1.492,1.606q0,1.272,0,2.545a1.237,1.237,0,0,1-.094.574.681.681,0,0,1-1.215-.073,1.608,1.608,0,0,1-.071-.565q0-1.331,0-2.66a.045.045,0,0,0-.045-.045Q397.018,160.808,395.584,160.816Z",
    transform: "translate(-328.987 -21.86)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M177.388,185.005a7.413,7.413,0,0,1-7.342-8.766,7.511,7.511,0,0,1,1.531-3.429,7.647,7.647,0,0,1,9.369-1.787,7.511,7.511,0,0,1,2.423,10.9A7.406,7.406,0,0,1,177.388,185.005Zm-5.508-4.8a6.067,6.067,0,1,0,7.836-8.228A6.086,6.086,0,0,0,171.879,180.2Z",
    transform: "translate(-123.498 -31.66)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M60.17,297.389q1.414.005,2.828,0c1.06,0,1.07,1.358-.035,1.37q-1.081.012-2.163.01c-.915,0-1.6-.024-1.95-.864a1.984,1.984,0,0,1-.11-.751q0-1.288,0-2.576a1.05,1.05,0,0,1,.117-.57.694.694,0,0,1,1.263.466q0,1.432,0,2.865A.041.041,0,0,0,60.17,297.389Z",
    transform: "translate(-21.919 -144.54)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M398.471,297.478q-.025-1.2-.007-2.414a5.664,5.664,0,0,1,.028-.661.686.686,0,0,1,1.349.217q0,1.32,0,2.639c0,1.074-.454,1.661-1.574,1.661l-2.661,0a1.008,1.008,0,0,1-.519-.107.7.7,0,0,1-.019-1.128,1.161,1.161,0,0,1,.6-.123q1.367,0,2.715,0a.082.082,0,0,0,.058-.024A.08.08,0,0,0,398.471,297.478Z",
    transform: "translate(-328.968 -144.709)",
    fill: "#f45000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_154-2",
    "data-name": "Path 154",
    d: "M42.317,32.26q-.862-.838-1.706-1.695a.691.691,0,0,1-.217-.581q0-1.554,0-3.107a1.245,1.245,0,0,1,.059-.456.632.632,0,0,1,1.165.028,1.221,1.221,0,0,1,.054.421q0,1.466,0,2.932a.047.047,0,0,0,.014.034q.694.7,1.387,1.388a1.167,1.167,0,0,1,.243.311A.632.632,0,0,1,42.317,32.26Z",
    transform: "translate(1131.607 488.954)",
    fill: "#f45000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage133);
export default __webpack_public_path__ + "static/media/Image-133.599f99b2c6f7f3c23ea8c7666baa2ecb.svg";
export { ForwardRef as ReactComponent };